import React, { Component } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import * as source from "sources/books/scenarios";
import Form from "./form";
import List from "./list";
import Show from "./show";

export default class Scenarios extends Component {
    componentWillUnmount() {
        this.props.clearParams("scenarios");
    }

    render() {
        const { match, location, history, canEditBooks } = this.props;
        const rootUrl = `${match.path}/list`;
        const back = () => history.push(rootUrl);
        return (
            <div className="page-content">
                <Switch location={location}>
                    <Route exact path={`${match.path}/`} render={() => <Redirect to={rootUrl} />} />
                    <Route
                        exact
                        path={rootUrl}
                        render={() => (
                            <List
                                {...this.props}
                                isTable
                                transition="full"
                                title="Список сценариев"
                                nofilter
                                createBtnText="Создать сценарий"
                            />
                        )}
                    />
                    <Route
                        path={`${rootUrl}/:id`}
                        render={(rest) => (
                            <Show {...rest} transition="full" title="Сценарий" back={back} source={source} />
                        )}
                    />
                    {canEditBooks() && (
                        <Route
                            path={`${match.path}/new`}
                            render={() => (
                                <Form {...this.props} title="Создать сценарий" back={back} submit={source.apply} />
                            )}
                        />
                    )}
                </Switch>
            </div>
        );
    }
}
